module.exports = __webpack_public_path__ + "fonts/Lyon.e85bf538.otf";